<nb-card>
  <nb-card-header i18n="@@CompanyChoosing">Выбор компании</nb-card-header>
  <nb-card-body>
    <p class="small text-muted mb-2"><ng-container i18n="@@TotalAvailable">Всего доступно</ng-container>: {{ contracts.length }}</p>

    <nb-form-field>
      <tui-icon nbPrefix icon="search"/>
      <input nbInput fullWidth type="text" [(ngModel)]="keyword" (ngModelChange)="onKey()"
             placeholder="Поиск" i18n-placeholder="@@Search">
    </nb-form-field>

    <nb-list>
      @for (contract of filteredContracts; track contract.id) {
        <nb-list-item class="d-flex justify-content-between align-items-center gap-2"
                      [class.selected]="selected == contract.id" (click)="select(contract)">
          <span class="d-flex flex-column">
            <span>{{ contract.counterParty?.company }}</span>
            @if (contract.header && contract.header !== contract.counterParty?.company) {
              <span class="small text-muted">{{ contract.header }}</span>
            }
          </span>
          @if (selected == contract.id) {
            <span tuiBadge appearance="info" i18n="@@Chosen">Выбрана</span>
          }
        </nb-list-item>
      }
    </nb-list>
  </nb-card-body>
</nb-card>
